import { ComboData } from "./ComboSimulador";

export const ComboPercentual: Array<ComboData> = [
  {
    Name: "0%",
    Value: "0"
  },
  {
    Name: "1%",
    Value: "1"
  },
  {
    Name: "2%",
    Value: "2"
  },
  {
    Name: "3%",
    Value: "3"
  },
  {
    Name: "4%",
    Value: "4"
  },
  {
    Name: "5%",
    Value: "5"
  },
  {
    Name: "6%",
    Value: "6"
  },
  {
    Name: "7%",
    Value: "7"
  },
  {
    Name: "8%",
    Value: "8"
  },
  {
    Name: "9%",
    Value: "9"
  },
  {
    Name: "10%",
    Value: "10"
  },
  {
    Name: "11%",
    Value: "11"
  },
  {
    Name: "12%",
    Value: "12"
  },
  {
    Name: "13%",
    Value: "13"
  },
  {
    Name: "14%",
    Value: "14"
  },
  {
    Name: "15%",
    Value: "15"
  },
  {
    Name: "16%",
    Value: "16"
  },
  {
    Name: "17%",
    Value: "17"
  },
  {
    Name: "18%",
    Value: "18"
  },
  {
    Name: "19%",
    Value: "19"
  },
  {
    Name: "20%",
    Value: "20"
  }
];